var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#29337A;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#D32030;}\r\n\t.st4{fill:#252F6C;}\r\n\t.st5{fill:#E51D35;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: -0.1,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8,6.8c-1,1.5-1.8,3.2-2.3,5h7.3L2.8,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,0.5C9.7,1.1,7.9,1.9,6.4,3l5.1,5.1V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.8,29c1.4,1,3,1.8,4.7,2.2v-6.9L6.8,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,20.6c0.5,1.7,1.3,3.3,2.4,4.7l4.7-4.7H0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.1,6.4C3,6.6,2.9,6.7,2.8,6.8l5,5H0.5c-0.1,0.4-0.2,0.9-0.3,1.4h9.6L3.1,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.4,28.7c0.1,0.1,0.2,0.2,0.4,0.3l4.7-4.7v6.9c0.4,0.1,0.9,0.2,1.4,0.3v-9.3L6.4,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,19.2c0.1,0.5,0.2,0.9,0.4,1.4h7.1l-4.7,4.7c0.5,0.7,1.1,1.4,1.7,2l8.1-8.1H0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.5,0.5v7.6L6.4,3c-0.7,0.5-1.3,1.1-2,1.7l8.4,8.4V0.2C12.4,0.3,11.9,0.4,11.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.5,20.5L11.5,20.5L11.5,20.5L11.5,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.8,19.2L12.8,19.2L12.8,19.2L12.8,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,13.2L19,13.2L19,13.2L19,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.5,11.8L11.5,11.8L11.5,11.8L11.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.9,13.1L12.9,13.1L12.9,13.1L12.9,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.3,27.7v3.6c1.7-0.5,3.3-1.2,4.7-2.2l-3.9-3.9C20.8,26.3,20.7,26.8,20.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.2,7.2L25.4,3c-1.5-1.1-3.3-2-5.1-2.5v3.7C20.8,5.2,20.8,5.9,21.2,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.8,25.4c1.1-1.4,1.9-3.1,2.4-4.8H24L28.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.5,11.8c-0.5-1.8-1.3-3.6-2.4-5.1L24,11.8H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.1,19.5l1.1,1.1l5.3,5.3c0.1-0.1,0.2-0.3,0.4-0.5L24,20.6h7.3c0.1-0.4,0.3-0.9,0.4-1.4h-9.4 C22.2,19.4,22.1,19.3,22.1,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21,8l4.8-4.8C25.7,3.1,25.5,3,25.4,3l-4.2,4.2C21.2,7.4,21,7.8,21,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,3.9V0.5c-0.4-0.1-0.9-0.2-1.4-0.3v1.7C19.4,2.4,19.9,3.1,20.3,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,13.2h9.7c-0.1-0.5-0.2-0.9-0.3-1.4H24l5.1-5.1c-0.5-0.7-1.1-1.4-1.7-2l-5.7,5.7 C21.9,11.5,21.9,12.1,22,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.9,24.9l4.1,4.1c0.7-0.5,1.3-1,1.9-1.6l-5.4-5.4C21.4,23.1,21.2,24,20.9,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.9,29.8v1.8c0.5-0.1,0.9-0.2,1.4-0.3v-3.6C19.9,28.5,19.4,29.2,18.9,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.7,10.4l5.7-5.7c-0.5-0.5-1.1-1-1.7-1.5l-4.5,4.5C21.5,8.6,21.6,9.5,21.7,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.2-0.1c0.3,0,0.5,0,0.8,0C15.7-0.1,15.4-0.1,15.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,31.9c-0.3,0-0.5,0-0.8,0C15.4,31.9,15.7,31.9,16,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,31.9c1,0,2-0.1,3-0.3v-1.8C18.1,30.7,17.1,31.9,16,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.7,13.2h-9.6c0.1,2,0.1,4.1,0,6.1h9.5c0.2-1.1,0.4-2.2,0.4-3.4C32,15,31.9,14,31.7,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.1,19.5c-0.1,0.9-0.4,1.7-0.6,2.6l5.4,5.4c0.5-0.5,1-1.1,1.5-1.6l-5.3-5.3L22.1,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.9,1.9V0.2C18,0,17-0.1,16-0.1C17.1-0.1,18.1,1,18.9,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.3,28.4c0.4-0.9,0.8-1.9,1.1-3l-1.1-1.1V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.6,6.8c-0.3-1.3-0.8-2.5-1.3-3.5v4.7L21.6,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.4,19.8c0-0.2,0-0.4,0.1-0.6h-0.6L22.4,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,8.1V3.4c-0.4-0.8-0.9-1.5-1.4-2.1v8.8l2.8-2.8c0-0.2-0.1-0.3-0.1-0.5L20.3,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19,13.2h3.5c-0.1-1.1-0.2-2.2-0.3-3.2L19,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.9,30.4c0.5-0.6,1-1.2,1.4-2.1v-4.1l1.1,1.1c0.3-0.9,0.5-1.9,0.6-2.9l-3.1-3.1L18.9,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.9,30.4v-11l3.1,3.1c0.2-0.9,0.3-1.8,0.4-2.8l-0.6-0.6h0.6c0.2-2,0.2-4.1,0-6.1H19l3.2-3.2 C22,9,21.9,8.2,21.7,7.3l-2.8,2.8V1.3c-0.8-0.9-1.8-1.4-3-1.4c-0.3,0-0.5,0-0.8,0c-0.8,0-1.6,0.1-2.3,0.3v12.9L4.5,4.7 C4,5.3,3.5,5.8,3.1,6.4l5.4,5.4l1.4,1.4H0.2C0.1,14,0,15,0,15.9c0,1.2,0.1,2.3,0.4,3.4h12.5l-8.1,8.1c0.5,0.5,1.1,1,1.7,1.4 l6.4-6.4v9.3c0.8,0.1,1.5,0.2,2.3,0.3c0.3,0,0.5,0,0.8,0C17.1,31.9,18.1,31.3,18.9,30.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglang);
export default __webpack_public_path__ + "static/media/englang.b0c4287ba13dc7e2b718dff3b92daf12.svg";
export { ForwardRef as ReactComponent };